import React, { useState } from 'react'
import useAxiosPrivate from '../hooks/useAxiosPrivate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faExclamationCircle, faSync } from '@fortawesome/free-solid-svg-icons';

const InvitationAction = ({ text, invitationId, endPoint, doneText, btnClasses, onSuccess }) => {
    const axiosPrivate = useAxiosPrivate();
    const [submitting, setSubmitting] = useState(false);
    const [response, setResponse] = useState(null);
    const handleAction = async (invitationId) => {
        try {
            setSubmitting(true);
            const response = await axiosPrivate.post(endPoint, { invitationId: invitationId });
            setResponse(response);
            if (onSuccess) {
                onSuccess(response);
            }
        } catch (error) {
            console.log('error :>> ', error);
            setResponse(error);
        } finally {
            setSubmitting(false);
        }
    };
    return (
        <>
            {
                !response &&
                <button type='button' className={`btn ${btnClasses}`}
                    disabled={submitting}
                    onClick={() => handleAction(invitationId)}>
                    {submitting ?
                        <span>
                            <FontAwesomeIcon icon={faSync} spin fixedWidth></FontAwesomeIcon> Processing...
                        </span>
                        :
                        text
                    }
                </button>
            }
            {
                response?.status === 200 &&
                <span className='text-success small text-nowrap'>
                    <FontAwesomeIcon icon={faCheck} fixedWidth /> {doneText}
                </span>
            }
            {
                response && response?.status !== 200 &&
                <div className='text-danger small'>
                    <FontAwesomeIcon icon={faExclamationCircle} fixedWidth /> {response?.data?.status?.value || response?.response?.data?.data || response?.message}
                </div>
            }
        </>
    )
}

export default InvitationAction
